import React, { useState } from 'react'
import logo from '../../assets/img/logo-small.svg'
import logoIcon from '../../assets/img/logo-icon-small.svg'
// import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Glass from '../Glass'
import './style.scss'
import System from '../../store/system'
import MenuIcon from '../MenuIcon'
import classNames from 'classnames'

interface MenuItem {
  id: string
  key: string
}

const menus: MenuItem[] = [
  { id: 'abilities', key: 'menu.abilities' },
  { id: 'highLight', key: 'menu.highLight' },
  { id: 'confidence', key: 'menu.confidence' },
  { id: 'model', key: 'menu.model' },
  { id: 'roadmap', key: 'menu.roadmap' },
  { id: 'team', key: 'menu.team' },
]

const PCMenu: React.FC = () => {
  const { t } = useTranslation('trans', { keyPrefix: 'header' })
  const handleGoto = (id: string): void => {
    document.querySelector(`#${id}`)?.scrollIntoView({
      behavior: 'smooth',
    })
  }

  return (
    <ul className="menu">
      {menus.map((menu) => (
        <li key={menu.key}>
          <a onClick={() => handleGoto(menu.id)}>{t(menu.key)}</a>
        </li>
      ))}
    </ul>
  )
}

interface MobileMenuProps {
  active: boolean
  setActive: (active: boolean) => void
}

const MobileMenu: React.FC<MobileMenuProps> = ({ active, setActive }) => {
  const { t } = useTranslation('trans', { keyPrefix: 'header' })

  const handleGoto = (id: string): void => {
    setActive(false)
    document.querySelector(`#${id}`)?.scrollIntoView({
      behavior: 'smooth',
    })
  }

  return (
    <>
      <MenuIcon active={active} onClick={setActive} />
      <ul className="menu">
        {menus.map((menu) => (
          <li key={menu.key}>
            <a onClick={() => handleGoto(menu.id)}>{t(menu.key)}</a>
          </li>
        ))}
      </ul>
    </>
  )
}

const Header: React.FC = () => {
  const [active, setActive] = useState(false)
  const { isMobile } = System.useContainer()

  return (
    <Glass
      rootTag="header"
      className={classNames('width-container', { active })}
      contentClassName="header-content"
      classic={isMobile}
    >
      <img className="logo" src={isMobile ? logoIcon : logo} alt="" />
      {isMobile ? (
        <MobileMenu active={active} setActive={setActive} />
      ) : (
        <PCMenu />
      )}
    </Glass>
  )
}

export default Header
